import { AGRICULTURE_HUMIDITY_LEVELS_COLORS } from "@/modules/agriculture/config/cultures.config";

export const humidityLvlColor = (percentage: number) => {
  const percentageInt = +percentage;
    let res = AGRICULTURE_HUMIDITY_LEVELS_COLORS.medium;
    percentageInt === 14
      ? (res = AGRICULTURE_HUMIDITY_LEVELS_COLORS.medium)
      : percentageInt > 14
      ? (res = AGRICULTURE_HUMIDITY_LEVELS_COLORS.wet)
      : (res = AGRICULTURE_HUMIDITY_LEVELS_COLORS.dry);
    return res;
  };